import React, { useCallback } from 'react';
import { translate } from '../../Services/translation';
import { uniqueId } from 'lodash';
import ProductCard from '../ProductCard/ProductCard';

const ProductsViewList = (props) => {
  const { products, cardClassName, className } = props;

  const getFieldId = () => uniqueId();

  return products?.length > 0 ? (
    <div className="section product-list-grid">
      {products.map((product) => (
        <ProductCard
          key={'pk' + product.id}
          {...product}
          fieldId={getFieldId()}
        />
      ))}
    </div>
  ) : null;
};

export default ProductsViewList;
